export default [
  {
    path: '/welcome',
    component: () => import('./RouteWelcome'),
    children: [
      {
        path: 'the-fundamentals',
        component: () => import('@/views/welcome/RouteWelcomeTheFundamentals'),
      },
      {
        path: 'educate',
        component: () => import('@/views/welcome/RouteWelcomeEducate'),
      },
      {
        path: 'get-in-touch',
        component: () => import('@/views/welcome/RouteWelcomeGetInTouch'),
      },
      {
        path: '*',
        redirect: '/welcome/the-fundamentals',
      },
    ],
  },
];
